import { IOdataFilter } from './IOdataFilter';
import { IOdataField } from '../Field/IOdataField';

export class OdataFilterEndsWith implements IOdataFilter {
  private field1: IOdataField;
  private field2: IOdataField;

  constructor(field: IOdataField, endsWithValue: IOdataField) {
    this.field1 = field;
    this.field2 = endsWithValue;
  }

  toFilterString() {
    return `endsWith(${this.field1.toFieldString()}, ${this.field2.toFieldString()})`;
  }
}
